import React, { useEffect } from 'react';
import { themes, activateTheme } from '../../canvasComponents/index';
// different error popups
import ErrorPopupGeneric from './ErrorPopupGeneric';
import ErrorPopUpServices from './ErrorPopUpServices';
// scss
import '../../css/components/PopUps/PopUps.scss';
// Error types
import { ENTERPRISE_SEARCH_LOCATIONS, NOT_DEFAULT_ERROR_POP_UP, AUDATARGET_SEARCH_VENDOR } from '../../containers/Error/ErrorTypes';

function ErrorPopup({ open, save, type, closeErrorPopUp }) {
  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);

  return (
    <>
      {!NOT_DEFAULT_ERROR_POP_UP.includes(type) && <ErrorPopupGeneric isSave={save} open={open} closeErrorPopUp={closeErrorPopUp} />}
      {NOT_DEFAULT_ERROR_POP_UP.includes(type) && (type === ENTERPRISE_SEARCH_LOCATIONS || type === AUDATARGET_SEARCH_VENDOR) && <ErrorPopUpServices open={open} closeErrorPopUp={closeErrorPopUp} service={type} />}
    </>
  );
}

export default ErrorPopup;
